module.exports = __webpack_public_path__ + "static/img/22.1d50d32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/22.png
// module id = Mvyb
// module chunks = 0